import * as React from 'react'

import { ParentSideMenu as ParentSideMenuPresenter, IProps } from './presenter'
export {
  PAGE_TYPE_PROFILE_TOP,
  PAGE_TYPE_PROFILE_EDIT_BASE,
  PAGE_TYPE_PROFILE_EDIT_CHILD,
  PAGE_TYPE_PROFILE_EDIT_CONTACT,
  PAGE_TYPE_PROFILE_EDIT_TEXT,
  PAGE_TYPE_PROFILE_EDIT_CREDENTIAL,
  PAGE_TYPE_PROFILE_EDIT_WELFARE,
  PAGE_TYPE_PROFILE_EDIT_CORP_APPLY,
} from './presenter'

export const ParentSideMenu = (props: IProps): JSX.Element => {
  return <ParentSideMenuPresenter {...props} />
}

export default ParentSideMenu
